<template>
    <rkm-layout-body title="Lista de baixa">
        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/almoxarifado/baixa/List'

export default {
    components: { List },
}
</script>